import { Tooltip } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { CustomButton } from '../../../components';
import { IMainCatalogItem } from '../../../shared/types/main-catalog';

interface IProcessesItemProps {
  process: IMainCatalogItem;
  page:
    | 'home'
    | 'catalog'
    | 'other'
    | 'basket'
    | 'publication'
    | 'favorite'
    | 'search'
    | 'searchPage'
    | 'cardPage'
    | 'order';
}

export const ProcessesItem: React.FC<IProcessesItemProps> = ({
  process,
  page,
}) => {
  return process ? (
    <Tooltip
      placement="bottom-start"
      title={
        process?.children.length > 0 ? (
          <ul className="processes__children">
            {process?.children.map((child) => (
              <li key={child?.id} className="processes__child">
                <Link to={`/processes/${child?.slug}`}>{child?.title}</Link>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )
      }
    >
      <li>
        <Link to={`/processes/${process?.slug}`}>
          <CustomButton
            variant={
              page === 'home' || page === 'publication' ? 'outlined' : 'gray'
            }
            className="processes__top__button"
          >
            {process?.title}
          </CustomButton>
        </Link>
      </li>
    </Tooltip>
  ) : (
    <></>
  );
};
